import React from 'react';
import { twMerge } from 'tailwind-merge';
export function Skeleton({
  className
}: {
  className?: string;
}) {
  return <div className={twMerge('animate-pulse rounded-sm bg-surface-2', className)} aria-hidden="true" data-id="element-837" data-mp="1d4a806vhaskp" />;
}